/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faIcons} from '@fortawesome/pro-duotone-svg-icons';

const AddGuardianIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faIcons} {...props} />
);

export default AddGuardianIcon;
